import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { BasePage } from "../layouts/genericPages/helpers/BasePage";
import { FindifySimpleHeader } from "../layouts/genericPages/components/FindifySimpleHeader";
import { MobileWorkspacesApi } from "../findifyv2-api-ts/mobile/workspaces/WorkspacesApi";
import { useRoute } from "@react-navigation/native";
import Geolocation, { GeolocationResponse } from "@react-native-community/geolocation";
import { FindifyTopBarOverlay } from "../layouts/genericPages/components/FindifyTopBarOverlay";
import { BaseFindifyList } from "@/layouts/genericPages/components/FindifyList";
import { makeDistanceString, selectWorkspace } from "./InitialPage";
import { getTranslatedString } from "@/layouts/genericPages/helpers/FindifyTranslatedString";
const geolib = require('geolib');


export const InitialPagePlacesList = ({ navigation, ...props }: any) => {
    const [items, setListItems] = useState<any[]>([]);
    const { t } = useTranslation();
    const findifyDataContext = useContext(FindifyDataContext);
    const router: any = useRoute();
    const [isFavList, setIsFavList] = useState(false);
    const [isNearList, setIsNearList] = useState(false);
    const [workspaceTypeId, setWorkspaceTypeId] = useState(-1);
    const [currentUserLocation, setCurrentUserLocation] = useState<GeolocationResponse | undefined>();
    const [distanceCalculated, setDistanceCalculated] = useState(false);

    useEffect(() => {
        Geolocation.getCurrentPosition(info => setCurrentUserLocation(info));
        let isFav = false;
        let isNear = false;
        let workspaceTypeId = -1;
        if (router?.params) {
            if (router.params['favourite_list']) {
                isFav = true;
            }
            if (router.params['nearby_list']) {
                isNear = true;
            }
            if (router.params['workspace_type_id']) {
                workspaceTypeId = router.params['workspace_type_id'];
            }
        }
        const mobileWorkspacesApi = new MobileWorkspacesApi();

        let limit = 100;
        let filters: any = {
            published_app_eq: 1,
            status_eq: 'active'
        };
        if (isFav) {
            filters['workspace_id_in'] = JSON.stringify(findifyDataContext?.favouriteWorkspaces);
            limit = findifyDataContext?.favouriteWorkspaces.length ?? 0;
        }
        if (workspaceTypeId > 0) {
            filters['workspace_type_id_eq'] = workspaceTypeId;
        }
        mobileWorkspacesApi.getList(0, limit, null, filters, null).then((data) => {
            setListItems(data.results);
        });

        setIsFavList(isFav);
        setIsNearList(isNear);
        setWorkspaceTypeId(workspaceTypeId);
    }, [])

    useEffect(() => {
        if (currentUserLocation && items && items.length && !distanceCalculated) {
            setDistanceCalculated(true);

            setListItems(items.map((item: any) => {
                const distanceInMeters = (currentUserLocation && item.latitude && item.longitude) ? geolib.getDistance(
                    { latitude: currentUserLocation.coords.latitude, longitude: currentUserLocation.coords.longitude },
                    { latitude: item.latitude, longitude: item.longitude }
                ) : undefined;
                item.distance = distanceInMeters;
                return item;
            }))
        }
    }, [currentUserLocation, items])


    return <BasePage navigation={navigation}>
        <FindifyTopBarOverlay />

        <BaseFindifyList
            enableGrid={true}
            items={items.map((item: any) => {
                return {
                    id: item.workspace_id,
                    image: item?.app_settings?.app_logo_url,
                    title: getTranslatedString(item.name, findifyDataContext),
                    resume: item.distance && makeDistanceString(item.distance),
                    onPress: () => {
                        selectWorkspace(item, findifyDataContext);
                    }
                };
            })}
            header={<FindifySimpleHeader navigation={navigation}
                title={
                    workspaceTypeId > 0 ? getTranslatedString(findifyDataContext.availableWorkspacesTypes.find((type: any) => type.workspace_type_id === workspaceTypeId)?.name, findifyDataContext) :
                        t(`initial_page.${isFavList ? 'favourite' : isNearList ? 'nearest' : 'available'}_places`)}
                actions={undefined}
                image={undefined} />}
            keyExtractor={(item, index) => index.toString()}
            selectLabel={t('list.read_more')} actions={undefined} />
    </BasePage >;
};

